module.exports = __webpack_public_path__ + "img/img26.d240b773.svg";